import { useStatQuery } from '@famly/stat_use-stat-query';
import { useSubscribableToggleFeatureMutationResult } from '@famly/stat_features_data';
import { StatPermissionsBase } from './stat-permissions-base.query';
export function useStatPermissionsBaseQuery(options) {
    const queryResult = useStatQuery(StatPermissionsBase, options);
    useSubscribableToggleFeatureMutationResult(result => {
        if (!result) {
            return;
        }
        const careRulesFeature = result.institutions.managedFeatures.setFeatures.find(feature => feature.featureId === 'CARE_RULES_OPT_OUT');
        if (careRulesFeature) {
            queryResult.updateQuery(cache => {
                // Care Rules is opt-out, so an enabled opt-out feature means no access
                cache.management.careRules.canView = !careRulesFeature.enabled;
                cache.management.careRules.canEdit = !careRulesFeature.enabled;
                return cache;
            });
        }
    });
    return queryResult;
}
